import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("admin@recettes-diabete.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      setToken(res.data.access_token);
      toast.success(`Bienvenue ${res.data.name}`);
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur de connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--bg-main))] p-6">
      <div className="w-full max-w-md" data-testid="admin-login-page">
        <a href="/" className="font-serif text-3xl tracking-tight">
          Recettes<span className="text-[hsl(var(--brand-primary))]">·</span>Diabete
        </a>
        <p className="overline mt-8 mb-2">Espace administrateur</p>
        <h1 className="font-serif text-4xl mb-8">Connexion</h1>

        <form onSubmit={submit} className="space-y-4 bg-white border border-[hsl(var(--border-light))] p-8 rounded-sm" data-testid="admin-login-form">
          <div>
            <label className="text-xs uppercase tracking-wider text-[hsl(var(--text-muted))]">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email-input"
              className="w-full mt-1 px-3 py-2.5 text-sm bg-white border border-[hsl(var(--border-light))] rounded-sm focus:outline-none focus:border-[hsl(var(--brand-primary))]"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-[hsl(var(--text-muted))]">Mot de passe</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password-input"
              className="w-full mt-1 px-3 py-2.5 text-sm bg-white border border-[hsl(var(--border-light))] rounded-sm focus:outline-none focus:border-[hsl(var(--brand-primary))]"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit-btn"
            className="btn-primary w-full disabled:opacity-50"
          >
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>

        <a href="/" className="block mt-6 text-xs uppercase tracking-wider text-[hsl(var(--text-muted))] hover:text-[hsl(var(--brand-primary))]">
          ← Retour au site
        </a>
      </div>
    </div>
  );
}
